import React, { Component } from 'react';
import Modal from '../Modal';
import api from '../../api';
import { BootstrapForm } from '../bootstrap/Form';

export default class RemoveAccountModal extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isSaving: false,
        }
    }

    handleRemoveAccount() {
        api.post(`users/remove_account`, {
            userId : this.props.userId,
        }).then(() => {
            window.location.href = `/team`;
        }).catch(error => {
            alert(error.toString())
            this.setState({
                isSaving : false
            })
        });
    }

    render() {
        const actionButton = this.state.isSaving ?
            (<button className="btn btn-danger disabled">Removing Account...</button>) :
            (<button className="btn btn-danger" onClick={this.handleRemoveAccount.bind(this)}>Remove</button>);

        return (
            <Modal actionButton={actionButton} className="modal-danger" title={"Remove Account"}>
                <BootstrapForm ref="form" inputs={this.state.inputs} className="form-horizontal">
                    <div>Are you sure you want to remove this account?</div>
                </BootstrapForm>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./app/components/modal/RemoveAccountModal.js